export enum ExecutionModeEnum {
    Offline = 'Offline',
    Online = 'Online',
}
